import { render, staticRenderFns } from "./AddSAMLConfiguration.vue?vue&type=template&id=649c2580"
import script from "./AddSAMLConfiguration.vue?vue&type=script&lang=js"
export * from "./AddSAMLConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports